import { io } from "socket.io-client";

// const socket = io("http://localhost:5007", {
//   autoConnect: false // ✅ CRITICAL
// });
const socket = io("https://royalking2.com:5007", {
  autoConnect: false // ✅ CRITICAL
});

export default socket;